import { useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import type { LanguageItem } from '../../types';
import { checkLanguageExists } from '../../utils/check-language-exists';
import { getSiteLanguage } from './get-site-language';

export function useAddSiteLanguage() {
  const { editMode, languages } = useSettings();

  return useMemo(() => {
    if (editMode || !languages) {
      return languages;
    }

    const siteLanguage = getSiteLanguage(languages);
    const isSiteLanguageExistsInApp =
      !!siteLanguage && checkLanguageExists(siteLanguage);

    if (!isSiteLanguageExistsInApp) {
      return languages;
    }

    const siteLangIndex = languages?.findIndex(
      ({ language }) => language === siteLanguage
    );

    const isLangAlreadyAdded = siteLangIndex !== -1;

    if (isLangAlreadyAdded) {
      return languages;
    }

    const siteLangItem = {
      id: `site-lang-${siteLanguage}`,
      language: siteLanguage
    } as LanguageItem;

    return [siteLangItem].concat(languages);
  }, [editMode, languages]);
}
